var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "url(#paint0_linear_14950_95)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2917 8.86095C23.6291 8.42372 23.5482 7.79575 23.1109 7.45833C22.6737 7.12091 22.0457 7.20182 21.7083 7.63905L23.2917 8.86095ZM18.4485 13.5L17.6879 14.1493C17.8835 14.3784 18.172 14.5071 18.4732 14.4997C18.7743 14.4923 19.0561 14.3494 19.2401 14.1109L18.4485 13.5ZM17.2605 10.5685C16.9019 10.1485 16.2707 10.0987 15.8507 10.4573C15.4307 10.8159 15.3809 11.4471 15.7395 11.8671L17.2605 10.5685ZM23.5 15C23.5 14.4477 23.0523 14 22.5 14C21.9477 14 21.5 14.4477 21.5 15H23.5ZM15 8.5C15.5523 8.5 16 8.05228 16 7.5C16 6.94772 15.5523 6.5 15 6.5V8.5ZM22.5 8.25L21.7083 7.63905L17.6568 12.8891L18.4485 13.5L19.2401 14.1109L23.2917 8.86095L22.5 8.25ZM18.4485 13.5L19.209 12.8507L17.2605 10.5685L16.5 11.2178L15.7395 11.8671L17.6879 14.1493L18.4485 13.5ZM22.5 15H21.5C21.5 18.5899 18.5899 21.5 15 21.5V22.5V23.5C19.6944 23.5 23.5 19.6944 23.5 15H22.5ZM15 22.5V21.5C11.4101 21.5 8.5 18.5899 8.5 15H7.5H6.5C6.5 19.6944 10.3056 23.5 15 23.5V22.5ZM7.5 15H8.5C8.5 11.4101 11.4101 8.5 15 8.5V7.5V6.5C10.3056 6.5 6.5 10.3056 6.5 15H7.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14950_95",
    x1: -4,
    y1: 2,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4BC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.89c44e9c64b1a67452c7df7d100d621a.svg";
export { ForwardRef as ReactComponent };